import {useMemo} from 'react';

import {CharacterItemSearchQuery, useCharacterItemSearchQuery} from '../../../../../generated/types';
import {searchItems} from '../../model/item-search';

export type SearchItem = CharacterItemSearchQuery['items'][number];

export const MIN_QUERY_LENGTH = 2;
const RESULTS_LIMIT = 30;

/** поиск по базе предметов: общий предмет с вариантами раскрывается в свои варианты */
export function useItemSearch(query: string, filter?: (item: SearchItem) => boolean) {
	const {data, loading, error} = useCharacterItemSearchQuery();

	const variantsByGeneric = useMemo(() => {
		const variants = new Map<string, SearchItem[]>();
		for (const item of data?.items || []) {
			if (item.parentId) variants.set(item.parentId, [...(variants.get(item.parentId) || []), item]);
		}
		return variants;
	}, [data]);

	const results = useMemo(() => {
		if (query.trim().length < MIN_QUERY_LENGTH) return [];
		const found = searchItems(data?.items || [], query, RESULTS_LIMIT)
			.flatMap((item) => variantsByGeneric.get(item.id) || [item])
			.filter((item) => !filter || filter(item));
		return [...new Map(found.map((item) => [item.id, item])).values()].slice(0, RESULTS_LIMIT);
	}, [data, variantsByGeneric, query, filter]);

	return {results, loading, error};
}
